export const apiUrl =
  "https://cycle-mate.herokuapp.com" || "http://localhost:4000";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
